import { Toast } from 'vant'
import router from '../router'

var first = '';

export function backListener() {
  //获取地址栏目中的url
  var urls = location.hash.split('/')[1]
  if (urls === '' || urls === 'login') {//判断是首页的时候点击二次退出app
    if (new Date().getTime() - first < 3000) {
      plus.runtime.quit();//表示退出app
    } else {
      Toast("再按一次退出应用");
      first = new Date().getTime();
    }
  } else {
    console.log('back')
    router.back()
  }
}
document.addEventListener('plusready', function (a) {
  plus.key.addEventListener('backbutton', backListener, false)
})

